import ChangeLanguage from "./ChangeLanguage"




const Settings = () => {


  return (
    <>
        <ChangeLanguage/>
    </>
  )
}

export default Settings